















































































































import { Vue, Watch, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
// import { logout } from '@/api/user';
import Context from '@/components/Context/index.vue';
import GlobalTimer from '@/components/Global Timer/index.vue';

@Component({
  components: {
    GlobalTimer,
    Context,
  },
})
export default class App extends Vue {
  @State((state) => state.Socket.message.session) session?: string

  // =============================================================================
  // Vue Hooks
  // =============================================================================

  async created() {
    this.checkMobileView();
    window.addEventListener('resize', this.checkMobileView);
    window.addEventListener('storage', (event) => { if (event.key === 'logout') this.logout(); });
    window.addEventListener('online', () => { this.off = false; });
    window.addEventListener('offline', () => { this.off = true; });
  }

  beforeUpdate() {
    if (!this.open) {
      this.onTabClick();
    }
  }

  logo = true

  mounted() {
    setInterval(() => {
      this.logo = !this.logo;
    }, 5000);
  }

  beforeMount() {
    this.onTabClick();
  }

  goToHome() {
    this.$router.push('/').catch(() => {});
    this.onTabClick();
  }

  // =============================================================================
  // Window Width
  // =============================================================================

  @State((state) => state.Global.widthWindow) widthWindow?: number

  checkMobileView() {
    this.$store.commit('getWidth', window.innerWidth);
    this.$store.commit('getHeight', window.innerHeight);
    this.onTabClick();
  }

  // =============================================================================
  // Navbar
  // =============================================================================

  open = false

  border = {
    left: 0,
    width: 0,
    height: 0,
  }

  get showNavBar(): Boolean {
    return (this.widthWindow || 0) > 960 || this.open;
  }

  onTabClick() {
    if (this.$route.path.split('/')[1] === '') {
      const styles = {
        left: 32,
        width: 59,
        height: 28,
      };
      this.border = styles;
    } else if (this.$route.path.split('/')[1] === 'overview') {
      const styles = {
        left: 32,
        width: 88,
        height: 28,
      };
      this.border = styles;
    } else {
      const tab = this.$route.path.split('/')[1] === '' ? document.getElementById('home') : document.getElementById(this.$route.path.split('/')[1]);
      const styles = {
        left: (tab as HTMLElement).offsetLeft + 32,
        width: (tab as HTMLElement).offsetWidth + 2,
        height: (tab as HTMLElement).offsetHeight,
      };
      this.border = styles;
    }
    if (this.$route.name !== 'GSL' && this.$route.name !== 'Caucus') document.body.style.overflow = 'visible';
    this.open = false;
  }

  toggleMenu() {
    if (this.open && this.$route.name !== 'GSL' && this.$route.name !== 'Caucus') {
      document.body.style.overflow = 'visible';
    } else {
      document.body.style.overflow = 'hidden';
    }
    this.open = !this.open;
  }

  capitalize = (string: string): string => {
    if (string === 'gsl') {
      return string.toUpperCase();
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // =============================================================================
  // General / Conference
  // =============================================================================

  conference = ['overview', 'delegates', 'gsl', 'motions', 'caucus', 'crisis'] as string[];

  general = ['home', 'conferences', 'connections', 'files', 'account'] as string[];

  routeGeneral = (string: string) => (string === 'home' ? '' : string);

  get pathCheckConference() {
    if (this.$route.path === '/') {
      return false;
    }
    return this.conference.includes(this.$route.path.split('/')[1]);
  }

  get pathCheckGeneral(): Boolean {
    if (this.$route.path === '/') {
      return true;
    }
    return this.general.includes(this.$route.path.split('/')[1]);
  }

  // =============================================================================
  // Logout
  // =============================================================================

  async logout(): Promise<void> {
    this.open = false;
    try {
      // await logout();
      this.$store.dispatch('logout');
      window.localStorage.setItem('logout', Date.now().toString());
      this.$router.push('/login');
    } catch (err) {
      console.error(err);
    }
  }

  // =============================================================================
  // Context Menu
  // =============================================================================

  @State((state) => state.Global.showContext) showContext?: boolean

  @State((state) => state.Global.contextPos) contextPos?: Array<number>

  config = {
    handler: () => { this.$store.dispatch('resetContext'); },
    events: ['click', 'touchstart', 'touchmove'],
  }

  // =============================================================================
  // Notifications
  // =============================================================================

  @State((state) => state.Global.notAuthorized) noAuth?: boolean

  @State((state) => state.Global.genericError) generic?: boolean

  @State((state) => state.Socket.isConnected) isConnected?: boolean

  state = false as boolean

  off = false as Boolean

  @Watch('isConnected')
  async offline(): Promise<boolean> {
    let timeout;
    if (this.state !== !this.isConnected) {
      timeout = await setTimeout(() => {
        this.state = !this.isConnected;
      }, 1000);
    } else {
      clearTimeout(timeout);
    }
    return this.state;
  }

  @Watch('noAuth')
  async onNoAuth() {
    let timeout;
    if (this.noAuth === true) {
      timeout = await setTimeout(() => {
        this.$store.commit('noAuth', false);
      }, 3000);
    } else {
      clearTimeout(timeout);
    }
  }

  @Watch('generic')
  async onGeneric() {
    let timeout;
    if (this.generic === true) {
      timeout = await setTimeout(() => {
        this.$store.commit('error', false);
      }, 3000);
    } else {
      clearTimeout(timeout);
    }
  }
}
